interface IItem {
  id: string
  price: number
  rating: number
  title: string
  image: string
}

export interface IState {
  basket: IItem[]
  user: any
}

export const initialState: IState = {
  basket: [],
  user: null
}

export enum DispatchTypes {
  ADD_TO_BASKET = 'ADD_TO_BASKET',
  SET_USER = 'SET_USER',
  REMOVE_FROM_BASKET = 'REMOVE_FROM_BASKET',
  EMPTY_BASKET = 'EMPTY_BASKET'
}

const reducer = (state: IState, action: any) => {
  // console.log(action)

  switch (action.type) {
    case DispatchTypes.ADD_TO_BASKET:
      return { ...state, basket: [...state.basket, action.item] }

    case DispatchTypes.EMPTY_BASKET:
      return { ...state, basket: [] }

    case DispatchTypes.REMOVE_FROM_BASKET:
      let newBasket = [...state.basket]
      const index = state.basket.findIndex((basketItem) => basketItem.id === action.id)
      if (index >= 0) newBasket.splice(index, 1)
      else console.warn(`Cant remove product (id: ${action.id}) as its not in basket!`)
      return { ...state, basket: newBasket }

    case DispatchTypes.SET_USER:
      return { ...state, user: action.user }

    default:
      return state
  }
}

export type TReducer = typeof reducer
export default reducer

// Selector
export const getBasketTotal = (basket: IState['basket']) =>
  basket?.reduce((amount: number, item: IItem) => item.price + amount, 0)
